import {Injectable} from "@angular/core";
import {createFeatureSelector, createSelector, Store} from "@ngrx/store";
import * as fromDatacenters from "../reducers/datacenter.reducer";
import {Observable} from "rxjs";


@Injectable()
export class DatacentersSelector {
  constructor(private readonly store: Store) {
  }

  getDatacentersState = createFeatureSelector<fromDatacenters.State>('datacenters');

  getChangedDatacenters(): Observable<any> {
    return this.store.select((createSelector(
      this.getDatacentersState,
      (state: fromDatacenters.State) => state.changedDatacenters
    )));
  };
}
